import FileDownloadIcon from '@mui/icons-material/FileDownloadOutlined'

import { JobMutationTrigger, JobMutationArgs } from 'common/contexts/types'
import { useExportJobContext } from 'common/contexts/useExportJobContext'

interface ICSVExportButton {
  mutationTrigger: JobMutationTrigger
  exportParams: JobMutationArgs
  fileName?: string
}

const CSVExportButton = ({
  mutationTrigger,
  exportParams,
  fileName
}: ICSVExportButton) => {
  const { isJobPending, createDataExportJob } = useExportJobContext()

  return (
    <div className='flex leading-6'>
      {isJobPending && (
        <div className='mr-8 text-gray-500'>Export Processing...</div>
      )}
      <button
        className={[
          'flex items-center',
          'font-medium leading-6 text-gray-700'
        ].join(' ')}
        onClick={() =>
          createDataExportJob(mutationTrigger, exportParams, fileName, '.csv')
        }
      >
        <FileDownloadIcon />
        <div className='ml-1'>Export Data</div>
      </button>
    </div>
  )
}

export default CSVExportButton
